import { MutationFunction, MutationResult } from '@apollo/client/react'
import { BasicsSection } from '@src/components/sco/InvestorMatching/InvestorMatchPitchBuilder/FormSections/BasicsSection'
import { FundingSection } from '@src/components/sco/InvestorMatching/InvestorMatchPitchBuilder/FormSections/FundingSection'
import { OptionsSection } from '@src/components/sco/InvestorMatching/InvestorMatchPitchBuilder/FormSections/OptionsSection'
import { PitchDeckSection } from '@src/components/sco/InvestorMatching/InvestorMatchPitchBuilder/FormSections/PitchDeckSection'
import { PitchSection } from '@src/components/sco/InvestorMatching/InvestorMatchPitchBuilder/FormSections/PitchSection'
import { TractionSection } from '@src/components/sco/InvestorMatching/InvestorMatchPitchBuilder/FormSections/TractionSection'
import { ScoInvestorSearch } from '@src/graphql-types'

export type PitchBuidlerFormProps = {
  investorSearch: ScoInvestorSearch
  upsertInvestorSearch: MutationFunction<any>
  upsertInvestorSearchMutation: MutationResult<any>
  onPrevSection?: () => void
  onNextSection?: () => void
}

const getProgressForValues = (
  values: any[]
): {
  totalSteps: number
  completedSteps: number
  percentComplete: number
} => {
  const totalSteps = values.length
  const completedSteps = values.filter(Boolean).length
  const percentComplete =
    totalSteps > 0 ? Math.max(10, Math.round((100 * completedSteps) / (totalSteps || 1))) : 100

  return {
    totalSteps,
    completedSteps,
    percentComplete,
  }
}

export const pitchBuilderSections = [
  {
    key: 'pitch-deck',
    title: '🔥 Fast Track - Upload Pitch Deck',
    FormComponent: PitchDeckSection,
    getProgress: (investorSearch: ScoInvestorSearch) => getProgressForValues([investorSearch.pitchDeckUrl]),
  },
  {
    key: 'basics',
    title: 'The Basics',
    FormComponent: BasicsSection,
    getProgress: (investorSearch: ScoInvestorSearch) =>
      getProgressForValues([
        investorSearch.companyName,
        investorSearch.companyWebsiteUrl,
        investorSearch.companyElevatorPitch,
      ]),
  },
  {
    key: 'pitch',
    title: 'Pitch',
    FormComponent: PitchSection,
    getProgress: (investorSearch: ScoInvestorSearch) =>
      getProgressForValues([
        investorSearch.problemStatement,
        investorSearch.solutionStatement,
        investorSearch.marketSizeStatement,
      ]),
  },
  {
    key: 'traction',
    title: 'Traction',
    FormComponent: TractionSection,
    getProgress: (investorSearch: ScoInvestorSearch) =>
      getProgressForValues([
        investorSearch.financialsStatement,
        investorSearch.tractionStatement,
        investorSearch.teamStatement,
      ]),
  },
  {
    key: 'ask',
    title: 'Funding Ask',
    FormComponent: FundingSection,
    getProgress: (investorSearch: ScoInvestorSearch) =>
      getProgressForValues([
        investorSearch.fundingGoalInDollars,
        investorSearch.fundingGoalStageKey,
        investorSearch.fundingGoalStructureKeys?.length,
      ]),
  },
  {
    key: 'options',
    title: 'Message Options',
    FormComponent: OptionsSection,
    getProgress: (investorSearch: ScoInvestorSearch) =>
      getProgressForValues([
        investorSearch.emailTemplatePrompt,
        investorSearch.emailTemplateSignature?.replaceAll('\n', '')?.replaceAll('<br>', '')?.trim(),
      ]),
  },
]
